import type { ContentBlock } from "../../blockTypes";
import BlockRenderer from "./BlockRenderer";

interface PromptBlocksProps {
    blocks?: ContentBlock[];
}

const PromptBlocks = ({ blocks }: PromptBlocksProps) => {
    if (!blocks?.length) return null;

    return (
        <div className="flex flex-col gap-3">
            {blocks.map((block, index) => (
                <BlockRenderer key={block.id ?? index} block={block} />
            ))}
        </div>
    );
};

export default PromptBlocks;